const facebookPixel = (action, event) => {
  if (window.fbq) window.fbq(action, event);
};

export default facebookPixel;
